<div class="app_sideDrawer uni-app-sidedrawer" [class]="!isCollapsed ? 'collapsed' : ''">
  <div class="box uni-filter-header-bg">
    <div>Criteria</div>
    <div (click)="handleClose(false)" class="cursor">X</div>
  </div>
  <div class="overFlow panel-filter">
    <div class="d-flex search-bar gap14">
      <div>
        <app-search
        [searchInput]="searchInput"
        (searchItem)="searchOnChange($event)"
        class="d-flex padt-5"
        [pageType]="pageType ?? (_tenantGenericConfig?.tenant === 'VOT' ? 'filter-panel-validops' :'filter-panel')"
      ></app-search>
      </div>
      <div class="d-flex align-items-center clear-all" *ngIf="hasFilters" (click)="clearAllFilters()">
        Clear All
      </div>
    </div>
    <form [formGroup]="filterForm" (ngSubmit)="onSubmit()" class="p-3">
      <div *ngFor="let filter of filterKeyValue">
        <h3 [style.color]="'#718294'">
          {{ filter[1]?.fieldName | titlecase }}
        </h3>
        <div formGroupName="{{ filter[0] }}" class="filter-make-responsive">
          <mat-checkbox
            *ngFor="let item of filter[1]?.fieldValues"
            [formControlName]="item.value"
            [checked]="isSingleSelection(filter[0]) ? isChecked(filter[0], item.value) : null"
            (change)="onCheckboxChange(filter[0], item.value, $event.checked)">
            {{ item.name }}
          </mat-checkbox>
        </div>
        <mat-divider></mat-divider>
      </div>
      <div *ngIf="includeAlerts?.include">
        <h3 [style.color]="'#718294'">{{includeAlerts?.fieldName}} <mat-checkbox [formControl]="isActiveAlerts"></mat-checkbox></h3>
      </div>
      <mat-divider *ngIf="includeAlerts?.include"></mat-divider>
      <div *ngIf="includeDtc?.include" >
        <h3 [style.color]="'#718294'">{{includeDtc?.fieldName}} <mat-checkbox [formControl]="isActiveDTCCases"></mat-checkbox></h3>
      </div>
      <mat-divider *ngIf="includeDtc?.include"></mat-divider>
      <div class="btn-basket">
        <button mat-raised-button type="submit" class="custom-button">Submit</button>
      </div>
    </form>
  </div>
</div>
